var mcb = mcb || {};

mcb.navigation = mcb.navigation || new function () {
    const categoryClick = function(e) {
        e.preventDefault();
        var target = e.currentTarget;
        var url = target.getAttribute('data-sticky-link');
        if (url) {
            mcb.url.utils.navigateToSticky(url);
        } else {
            var href = target.getAttribute('href');
            if (href) {
                mcb.url.utils.navigateToSticky(href);
            }
        }
    }

    this.init = function () {
        const nav = document.querySelector(".primary-nav");
        const ddToggle = document.querySelector("#course_dropdown > .dropdown-toggle");
        const searchBox = document.querySelector(".search-box");
        const stickyLinks = document.querySelectorAll("[data-sticky-link]");

        if (searchBox) {           
            const btn = searchBox.querySelector("button[type=submit]");
            if (btn) {
                btn.addEventListener("click", e => {
                    if (searchBox.classList.contains("shrinked")) {
                        e.preventDefault();
                    }
                    searchBox.classList.remove("shrinked");
                    searchBox.focus();
                });
            }
        }

        if (ddToggle) {
            ddToggle.addEventListener("show.bs.dropdown", () => {
                const overlay = document.createElement("div");
                overlay.className = "screen-darken show fade";
                nav.appendChild(overlay);
            });

            ddToggle.addEventListener("hide.bs.dropdown", () => {
                const overlay = nav.querySelector(".screen-darken");
                if (overlay) {
                    nav.removeChild(overlay);
                }
            });
        }

        if (stickyLinks) {
            for (var i = 0; i < stickyLinks.length; i++) {
                stickyLinks[i].addEventListener('click', categoryClick);
            }
        }
    };
}();